// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"c5bde5b2","525":"bc447627","759":"6b31de8b","845":"cbdc7510","991":"8b325686"}[chunkId] + ".chunk.js";
};